import React from 'react';

import { ActionIcon, Tooltip } from '@mantine/core';
import { IconFilterOff } from '@tabler/icons-react';

const ClearFilters = ({
  onClick,
  className,
  disabled,
}: {
  onClick: () => void;
  className?: string;
  disabled?: boolean;
}): JSX.Element => {
  return (
    <Tooltip label='Clear filters' className={className}>
      <ActionIcon onClick={onClick} disabled={disabled}>
        <IconFilterOff />
      </ActionIcon>
    </Tooltip>
  );
};

export default ClearFilters;
